import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { PropsWithChildren } from "react";

interface Props {
    width?: number;
    large?: boolean;
    xlarge?: boolean;
    full?: boolean;
    className?: string;
    testId?: string;
}

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        flexDirection: "column",
        maxWidth: "400px"
    },
    large: {
        maxWidth: "600px"
    },
    xlarge: {
        maxWidth: "800px"
    },
    full: {
        maxWidth: "none"
    }
}));

const SettingsForm: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();
    return (
        <div
            data-cy={props.testId}
            className={clsx(
                classes.root,
                props.large && classes.large,
                props.xlarge && classes.xlarge,
                props.full && classes.full,
                props.className
            )}
            style={props.width ? {
                maxWidth: `${props.width}px`
            } : undefined}>
            {props.children}
        </div>
    );
};

export default SettingsForm;
